'use client';

import Image from 'next/image';
import Link from 'next/link';
import { Instagram } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-[#111111] section-dark text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Image
                src="/images/uploads/b4695024-1a45-4658-bd2d-f01ae33d76b0.png"
                alt="Mo's Burger Logo"
                width={40}
                height={40}
                className="h-10 w-auto"
              />
              <span className="font-black text-xl text-white">Mo's Burger</span>
            </div>
            <p className="text-white/70 text-sm">
              100% Halal certified smash burgers. Fresh. Made to order. Open late.
            </p>
          </div>

          {/* Order Online */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#D71920]">Order Online</h3>
            <ul className="space-y-2 text-sm text-white/70">
              <li>
                <button
                  onClick={() => window.location.href = 'https://www.toasttab.com/local/order/mos-burger-llc-3709-s-george-mason-dr-1204e'}
                  className="hover:text-[#D71920] transition-colors text-left font-semibold"
                >
                  Toast
                </button>
              </li>
              <li><button onClick={() => window.location.href = 'https://www.ubereats.com/store/mos-burger-500-florida-avenue-northeast/OBre9dneUZSHCeqYN2bBMQ?diningMode=DELIVERY&ps=1&surfaceName='} className="hover:text-[#D71920] transition-colors text-left">Uber Eats</button></li>
              <li><button onClick={() => window.location.href = 'https://www.doordash.com/store/37328131?src=yp&delivery=true&utm_source_id=3a4b9245-6353-4f6b-825a-695d0e735a11'} className="hover:text-[#D71920] transition-colors text-left">DoorDash</button></li>
              <li><button onClick={() => window.location.href = 'https://www.grubhub.com'} className="hover:text-[#D71920] transition-colors text-left">Grubhub</button></li>
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#D71920]">Navigation</h3>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link href="/" className="hover:text-[#D71920] transition-colors">Home</Link></li>
              <li><Link href="/about" className="hover:text-[#D71920] transition-colors">About Mo</Link></li>
              <li><a href="/#menu" className="hover:text-[#D71920] transition-colors">Menu</a></li>
              <li><button onClick={() => window.location.href = 'mailto:Catering@mosburgerdc.com?subject=Mo\'s%20Burger%20Catering%20Inquiry'} className="hover:text-[#D71920] transition-colors text-left">Catering</button></li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#D71920]">More</h3>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="/#location" className="hover:text-[#D71920] transition-colors">Location</a></li>
              <li><a href="/#gallery" className="hover:text-[#D71920] transition-colors">Gallery</a></li>
              <li><a href="https://www.instagram.com/mosburgerdmv/" target="_blank" rel="noopener noreferrer" className="hover:text-[#D71920] transition-colors">Instagram</a></li>
              <li><a href="tel:+17037123456" className="hover:text-[#D71920] transition-colors">Call Us</a></li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#D71920]">Hours</h3>
            <div className="text-sm text-white/70 space-y-2">
              <p>To Be Announced</p>
              <p className="text-xs text-white/50 mt-3 font-semibold">
                Follow @mosburgerdmv on Instagram for today's hours & location.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/10 pt-8">
          {/* Branded phrase - matches menu image */}
          <div className="text-center mb-6">
            <p className="text-white text-sm sm:text-base font-black uppercase tracking-widest">
              🔥 HANDMADE • FRESH • HALAL • FLAVOR 🔥
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-amber-100 text-sm">
              © 2026 Mo's Burger. All rights reserved.
            </p>
            <a
              href="https://www.instagram.com/mosburgerdmv/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-amber-100 hover:text-white transition-colors mt-4 md:mt-0"
            >
              <Instagram className="h-6 w-6" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
